import * as ComponentConstants from "../constants/component.constant";

const initialState = {
  mobileNav: false,
  loading: "",
};

const componentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ComponentConstants.TOGGLE_MOBILE_NAV:
      return { ...state, mobileNav: action.payload };
    default:
      return state;
  }
};

export default componentReducer;
